import { render, staticRenderFns } from "./LogoPositioningSection.vue?vue&type=template&id=2fd61286"
import script from "./LogoPositioningSection.vue?vue&type=script&lang=ts"
export * from "./LogoPositioningSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoPositioningSection.vue?vue&type=style&index=0&id=2fd61286&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports